export default __webpack_public_path__ + "static/media/logo_AGRITER-web-transparent.6ff1e178.png";